import * as React from "react";
import Select, { createFilter } from "react-select";
import AsyncSelect from "react-select/async";
import OptimizedMenuList from "./optimized-menu-list";
import OptimizedOption from "./optimized-option";

export default (props: any) => {
  if (props.async) {
    return (
      <AsyncSelect
        components={
          props.ignoreCustomComponents
            ? {}
            : { MenuList: OptimizedMenuList, Option: OptimizedOption }
        }
        menuPortalTarget={props.portal && document.body}
        blurInputOnSelect={true}
        {...props}
      />
    );
  }
  return (
    <Select
      components={
        props.ignoreCustomComponents ? {} : { MenuList: OptimizedMenuList, Option: OptimizedOption }
      }
      filterOption={createFilter({ ignoreAccents: false })}
      menuPortalTarget={props.portal && document.body}
      blurInputOnSelect={true}
      {...props}
    />
  );
};
